/* unplugin-vue-components disabled */import script from "./NoManageDays.vue?vue&type=script&setup=true&lang=js"
export * from "./NoManageDays.vue?vue&type=script&setup=true&lang=js"

import "./NoManageDays.vue?vue&type=style&index=0&id=99365420&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-99365420"]])

export default __exports__